<template>
  <path
    d="M12 4.50024C7 4.50024 2.73 7.61024 1 12.0002C2.73 16.3902 7 19.5002 12 19.5002C17 19.5002 21.27 16.3902 23 12.0002C21.27 7.61024 17 4.50024 12 4.50024ZM12 17.0002C9.24 17.0002 7 14.7602 7 12.0002C7 9.24024 9.24 7.00024 12 7.00024C14.76 7.00024 17 9.24024 17 12.0002C17 14.7602 14.76 17.0002 12 17.0002ZM12 9.00024C10.34 9.00024 9 10.3402 9 12.0002C9 13.6602 10.34 15.0002 12 15.0002C13.66 15.0002 15 13.6602 15 12.0002C15 10.3402 13.66 9.00024 12 9.00024Z"
  />
</template>
